import api, { buildQueryParams } from './api';

export const getEquipment = async (params = {}) => {
    try {
        let url = '/api/inventory/equipment/';
        const queryString = buildQueryParams(params);
        if (queryString) {
            url += `?${queryString}`;
        }
        const response = await api.get(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getEquipmentItem = async (id) => {
    try {
        const response = await api.get(`/api/master-data/equipment/${id}/`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const createEquipment = async (data) => {
    try {
        const response = await api.post('/api/master-data/equipment/', data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateEquipment = async (id, data) => {
    try {
        const response = await api.put(`/api/master-data/equipment/${id}/`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deleteEquipment = async (id) => {
    try {
        await api.delete(`/api/master-data/equipment/${id}/`);
    } catch (error) {
        throw error;
    }
};

export const updateEquipmentStatus = async (id, status) => {
    try {
        const response = await api.post(`/api/master-data/equipment/${id}/update_status/`, { status });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getEquipmentStatusChoices = async () => {
    try {
        const response = await api.get('/api/master-data/equipment/status_choices/');
        return response.data.status_choices;
    } catch (error) {
        throw error;
    }
};

export const debugEquipment = async () => {
    try {
        const response = await api.get('/api/inventory/equipment/debug/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getEquipmentServiceOrders = async (equipmentId) => {
    try {
        const response = await api.get(`/api/inventory/equipment/${equipmentId}/service_orders/`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateMasterDataEquipmentStatus = async (equipmentId, newStatus) => {
    try {
        const response = await api.post(`/api/master-data/equipment/${equipmentId}/update_status/`, {
            status: newStatus
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const deallocateEquipmentFromServiceOrders = async (equipmentId) => {
    try {
        const response = await api.post(`/api/master-data/equipment/${equipmentId}/deallocate_from_service_orders/`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
